// Generated by CoffeeScript 1.12.7
(function() {
  var VASTCompanionAd;

  VASTCompanionAd = (function() {
    function VASTCompanionAd() {
      this.id = null;
      this.width = 0;
      this.height = 0;
      this.type = null;
      this.staticResource = null;
      this.htmlResource = null;
      this.iframeResource = null;
      this.altText = null;
      this.companionClickThroughURLTemplate = null;
      this.companionClickTrackingURLTemplates = [];
      this.trackingEvents = {};
    }

    return VASTCompanionAd;

  })();

  module.exports = VASTCompanionAd;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ../~/vast-client/dist/companionad.js
// module id = 26
// module chunks = 0